var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"adminUserDisplay"},[_c('span',{staticClass:"userreal_name"},[_vm._v(_vm._s(_vm.companyname)+" - "+_vm._s(_vm.storename)+" - "+_vm._s(_vm.username))])])}
var staticRenderFns = []

export { render, staticRenderFns }